"use strict";

Shopify.theme.jsAnnouncementBar = {
  init: function init($section) {
    var _this = this;

    // Add settings from schema to current object
    Shopify.theme.jsAnnouncementBar = $.extend(this, Shopify.theme.getSectionData($section));
    var template = this.homepage_only ? '.index' : '';
    this.$el = $('#announcement-bar', template);
    this.animationStyle = this.$el.data('animation');
    this.animationSpeed = parseInt(this.$el.data('speed'), 10) || 10; // Default speed

    var announcementCookie = Cookies.get('announcement-bar');
    $('.announcement-bar__shadow').height(this.$el.height());

    if (this.show_close_icon === false) {
      Cookies.remove('announcement-bar');
      $('body').addClass('announcement-bar--visible');

      if (Shopify.theme_settings.header_layout == 'vertical') {
        this.addVerticalHeaderTopMargin();
      }
    } else if (announcementCookie !== 'dismiss') {
      $('body').addClass('announcement-bar--visible');

      if (Shopify.theme_settings.header_layout == 'vertical') {
        this.addVerticalHeaderTopMargin();
      }
    } else {
      $('body').addClass('announcement-bar--hidden');
      this.disableSticky();

      if (Shopify.theme_settings.header_layout == 'vertical') {
        this.removeVerticalHeaderTopMargin();
      }
      return false;
    }

    if (this.enable_sticky === true) {
      this.enableSticky();
    } else {
      this.disableSticky();
    }

    if (this.show_close_icon === true) {
      $('body').addClass('has-announcement-bar-toggle');
      this.$el.on('click', '.js-close-announcement', function () {
        _this.hide();
        if (Shopify.theme_settings.header_layout == 'vertical') {
          _this.removeVerticalHeaderTopMargin();
        }
      });
    }

    // Start animation based on the selected style
    this.applyAnimation();
  },

  applyAnimation: function applyAnimation() {
    if (this.animationStyle === "marquee") {
      this.startMarqueeEffect();
    } else if (this.animationStyle === "typing") {
      this.startTypingEffect();
    }
  },

  startMarqueeEffect: function startMarqueeEffect() {
    const textContainer = this.$el.find(".custom-announcement-text");
    textContainer.css({
      "white-space": "nowrap", // Ensures text stays on a single line
      "display": "inline-block",
      "animation": `marquee-scroll ${this.animationSpeed}s linear infinite`
    });

    // Wrap text inside a div for scrolling effect
    if (!textContainer.parent().hasClass("marquee-wrapper")) {
      textContainer.wrap('<div class="marquee-wrapper"></div>');
      $(".marquee-wrapper").css({
        "overflow": "hidden",
        "display": "flex",
        "align-items": "center",
        "width": "100%"
      });
    }
  },

  startTypingEffect: function startTypingEffect() {
    const textContainer = this.$el.find(".custom-announcement-text");
    let text = textContainer.html().replace(/<span class="mobile-break">.*?<\/span>/g, "\n").trim(); // Fix HTML issue
    let lines = text.split("\n"); // Split text by lines
    textContainer.html(""); // Clear text before animation

    let lineIndex = 0;
    let _this = this;

    function typeLine() {
      if (lineIndex >= lines.length) return; // Stop when all lines are typed

      let lineText = lines[lineIndex];
      let charIndex = 0;
      let lineSpan = $("<span></span>").addClass("typing-line");
      textContainer.append(lineSpan);

      function typeChar() {
        if (charIndex < lineText.length) {
          lineSpan.append(lineText[charIndex]);
          charIndex++;
          setTimeout(typeChar, _this.animationSpeed * 5); // Character speed
        } else {
          textContainer.append("<br>"); // Line break
          lineIndex++;
          setTimeout(typeLine, _this.animationSpeed * 200); // Delay before next line
        }
      }
      typeChar();
    }
    typeLine();
  },

  addVerticalHeaderTopMargin: function addVerticalHeaderTopMargin() {
    if (isScreenSizeLarge()) {
      $('.header--vertical').css('marginTop', -this.$el.height());
      $('.announcement-bar__shadow').height(this.$el.height());
    }
  },

  removeVerticalHeaderTopMargin: function removeVerticalHeaderTopMargin() {
    $('.header--vertical').removeAttr('style');
  },

  enableSticky: function enableSticky() {
    this.$el.parent().sticky({
      wrapperClassName: 'announcement-sticky-wrapper',
      zIndex: 40
    });
    this.resetHeader(this.$el.height());
  },

  disableSticky: function disableSticky() {
    this.$el.parent().unstick();
    this.resetHeader(0);
  },

  hide: function hide() {
    $('body').removeClass('announcement-bar--visible');
    this.disableSticky();
    Cookies.set('announcement-bar', 'dismiss', {
      expires: 30
    });
  },

  resetHeader: function resetHeader(offset) {
    if (Shopify.theme.jsHeader.enable_sticky === true && isScreenSizeLarge()) {
      if (Shopify.theme_settings.header_layout != 'vertical') {
        Shopify.theme.jsHeader.disableSticky();
        Shopify.theme.jsHeader.enableSticky(offset);
      }
    } else if (Shopify.theme.jsHeader.enable_sticky === true && !isScreenSizeLarge()) {
      Shopify.theme.mobileMenu.disableSticky();
      Shopify.theme.mobileMenu.enableSticky(offset);
    }
  },

  getAnnouncementHeight: function getAnnouncementHeight() {
    return $('.announcement-container').outerHeight() || 0;
  },

  unload: function unload($section) {
    $('#announcement-bar').off();
    $('#announcement-bar').unstick();
  }
};
